<!--*
 * Button that changes language of the app
 *
 * @author   pablo.barco
 * @date     2020-06-19
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <smtt-dropdown class="float-right" :name="name" icon="language">
    <smtt-dropdown-item v-for="language in languages" :key="language.key" @click="changeLanguage(language.key)">
      <b v-if="language.key == currentLocale">{{ language.value }}</b>
      <span v-else>{{ language.value }}</span>
    </smtt-dropdown-item>
  </smtt-dropdown>
</template>

<script>
import { mapActions } from 'vuex';

import { languageNames } from '../../i18n/main';

export default {
  'name': 'LanguageButton',
  data() {
    return {
      'languages': languageNames,
    }
  },
  'computed': {
    name() {
      return this.$t('login.language.change.button.label');
    },
    currentLocale() {
      return this.$i18n.locale();
    }
  },
  'methods': {
    ...mapActions([
      'changeLocale'
    ]),
    'changeLanguage': function (language) {
      this.$i18n.set(language);
      this.changeLocale({ 'locale': language });
      this.$emit('onChangeLocale');
    }
  }
}
</script>

<style scoped>
</style>
